import {Button, styled, Tooltip, Typography} from '@mui/material';
import Box from '@mui/material/Box';
import {
  useCallback,
  useState,
  useMemo,
  memo,
  forwardRef,
  useRef,
  useImperativeHandle,
  useEffect,
} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {approveExpenseStateSelector} from '@app/screens/module-specific-utilities/pages/approve-expenses/redux/selectors';
import {
  uploadMiscExpenseDataCreator,
  miscSaveCreator,
  fetchBilDetailsCreator,
} from '@app/screens/module-specific-utilities/pages/approve-expenses/redux/slice';
import {ViewBillPopup} from './sub-components/ViewBillPopup';
import {approveExpenseStateActions} from '@app/screens/module-specific-utilities/pages/approve-expenses/redux';
import {
  dailyDataGrid,
  nameStyles,
  referColor,
  useStyles,
} from '@app/screens/Styles/style';
import {ToasterService} from '@app/services';
import {ToastType} from '@app/services/toaster';
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import '../approve-expenses/styles/ApproveExpenseMiscEditableGridStyle.css';
import UploadBillPopup from './BillPopup/BillDialog';
import theme from '@app/themes';
import {styles} from './styles/customStyle';
import {strings} from '@app/common/strings';
import {debounce} from 'lodash';

const ROW_HIGHT = 30;

export const NumberInput = memo(
  forwardRef((props: any, ref) => {
    const [value, setValue] = useState<any>(props?.value);
    let hasError = false;
    const refInput = useRef(null);
    if (
      (['Unlock Deduction', 'DA Adjustment', 'TA Adjustment'].includes(
        props.data.expenseType,
      ) &&
        parseInt(value) < 0) ||
      (parseInt(value) > 0 &&
        !['Unlock Deduction'].includes(props?.data?.expenseType))
    ) {
      hasError = true;
    }
    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value;
        },

        isCancelBeforeStart() {
          return false;
        },
      };
    });

    return (
      <input
        ref={refInput}
        value={value}
        onChange={event => {
          let val = event?.target?.value?.substring(
            0,
            event?.target?.value?.length - (event?.target?.value?.length - 6),
          );
          if (
            props?.data?.expenseType == strings.TAAdjustment ||
            props?.data?.expenseType == strings.DAAdjustment
          ) {
            val = val?.replace(/[^0-9-]/g, '');
          } else if (props?.data?.expenseType == strings.UnlockDeduction) {
            val =
              val?.startsWith('-') || val?.startsWith('0')
                ? val?.replace(/[^0-9-]/g, '')
                : '';
          } else {
            val = val?.replace(/\D/g, '');
          }
          setValue(val);
        }}
        className={`number-input ${!hasError && 'number-input-error'}`}
      />
    );
  }),
);

export const util: any = {
  onViewBillClickfuntion: null,
  renderUploadCell: null,
  convertBase64: null,
  changeHandlers: null,
  uploadButton: null,
  colorChange: null,
  viewBill: null,
  onRowValueChanged: null,
  style: null,
  resonValidation: null,
  request: null,
  filterArr: null,
  condtionCheck: null,
};

export const NoRecordsFoundBox = ({
  isDailyScreen = false,
}: {
  isDailyScreen?: boolean;
}) => (
  <Box
    sx={{
      border: 2,
      mb: isDailyScreen ? 0 : 7,
    }}>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mt: 10,
        mb: 10,
      }}>
      <Typography>{strings.noRecordFound}</Typography>
    </Box>
  </Box>
);

const ApproveExpenseMiscEditableGrid = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [expenseId, setExpenseId] = useState('');
  const [billPopup, setBillPopup] = useState(false);
  const [staffPositionId, setStaffPositionId] = useState('');
  const miscEditedRowColorIndex =
    useSelector(approveExpenseStateSelector.getMiscEditedRowColorIndex()) ?? [];
  const expenseApprovalsMisc: any[] =
    useSelector(approveExpenseStateSelector?.getMiscExpenseApprovalsData()) ??
    [];
  const status = useSelector(
    approveExpenseStateSelector.getApproveExpensestatus(),
  );
  const miscSort = useSelector(approveExpenseStateSelector.getMiscSort());
  const tableWidth = useSelector(
    approveExpenseStateSelector.getMiscTableWidth(),
  );
  const [expandedWidth, setExpandedWidth] = useState(tableWidth);
  const [rowData, setRowData] = useState<any>(null);
  const [gridApi, setGridApi] = useState<any>(null);
  const rowVal = () => {
    let datagrid = expenseApprovalsMisc?.map(({...rest}) => ({
      ...rest,
      ['isEditable']: status?.expenseStatusId === 9,
    }));
    return datagrid;
  };

  useEffect(() => {
    if (gridApi) {
      gridApi.refreshCells({force: true});
    }
  }, [rowData, gridApi]);

  useEffect(() => {
    setRowData(rowVal());
  }, [expenseApprovalsMisc, status]);

  useEffect(() => {
    dispatch(approveExpenseStateActions.setMiscEditedRowColorIndex([]));
  }, []);

  useEffect(() => {
    return () => {
      dispatch(approveExpenseStateActions.setMiscTableWidth(expandedWidth));
    };
  }, [expandedWidth]);

  const onViewBillClickfuntion = (params: any) => {
    const miscExpenseParamsData = {...params?.data};
    let request = {
      id: params?.data?.expMiscHistoyId,
      page: 'misc',
    };
    setExpenseId(params?.data?.expMiscHistoyId);
    dispatch(fetchBilDetailsCreator(request));
    dispatch(approveExpenseStateActions.setViewBillPopupVisible(true));
    dispatch(approveExpenseStateActions.setMiscExpense(miscExpenseParamsData));
  };
  const uploadButton = (params: any) => {
    const miscExpenseParamsData = {...params?.data};
    setBillPopup(true);
    setExpenseId(params?.data?.expMiscHistoyId);
    setStaffPositionId(params?.data?.staffPositionId);
    dispatch(approveExpenseStateActions.setMiscExpense(miscExpenseParamsData));
  };

  const viewBill = (props: any) => {
    if (props?.data?.isBillsUploaded) {
      return (
        <Button
          size="small"
          variant="contained"
          data-testid={`ViewBillClick`}
          onClick={() => onViewBillClickfuntion(props)}>
          {strings.view}
        </Button>
      );
    } else {
      return null;
    }
  };

  const renderUploadCell = (params: any) => {
    return (
      <Button
        variant="contained"
        component="span"
        data-testid="uploadButton"
        size="small"
        onClick={() => uploadButton(params)}
        disabled={status?.expenseStatusId !== 9}>
        {strings.upload}
      </Button>
    );
  };

  const style = (params: any) => {
    if (status?.expenseStatusId == 9) {
      if (miscEditedRowColorIndex?.includes(params?.data?.expMiscHistoyId)) {
        return {backgroundColor: theme.colors.red[1300]};
      }
      return {backgroundColor: theme.colors.yellow[700]};
    }
  };
  const style1 = (params: any) => {
    if (status?.expenseStatusId == 9) {
      return {backgroundColor: theme.colors.yellow[700]};
    }
  };
  const renderExpenseType = (params: any) => {
    return (
      <Tooltip title={params?.data?.expenseType || ''}>
        <span>{params?.data?.expenseType}</span>
      </Tooltip>
    );
  };

  const sortedDirection = (columnName: string) =>
    columnName === miscSort.field ? miscSort.sortDirection : '';

  const columns: any = [
    {
      field: strings.ModuleSpecificUtilitie.approveExpense.expenseType,
      headerName: strings.ModuleSpecificUtilitie.approveExpense.EXPENSE_TYPE,
      width: expandedWidth.expenseType,
      pinned: true,
      maxWidth: 300,
      editable: false,
      cellRenderer: renderExpenseType,
      sort: sortedDirection(
        strings.ModuleSpecificUtilitie.approveExpense.expenseType,
      ),
    },
    {
      field: strings.ModuleSpecificUtilitie.approveExpense.amount,
      headerName: strings.ModuleSpecificUtilitie.approveExpense.AMOUNT,
      width: 130,
      pinned: true,
      maxWidth: 200,
      editable: false,
      cellRenderer: (params: any) => {
        return params?.data?.amount ? params?.data?.amount : '';
      },
      sort: sortedDirection(
        strings.ModuleSpecificUtilitie.approveExpense.amount,
      ),
    },
    {
      field: strings.ModuleSpecificUtilitie.approveExpense.amountClaimed,
      headerName: strings.ModuleSpecificUtilitie.approveExpense.AMOUNT_CLAIMED,
      width: 150,
      editable: false,
      maxWidth: 200,
      cellRenderer: (params: any) => {
        return params?.data?.amountClaimed ? params?.data?.amountClaimed : '';
      },
      sort: sortedDirection(
        strings.ModuleSpecificUtilitie.approveExpense.amountClaimed,
      ),
    },
    {
      field: strings.ModuleSpecificUtilitie.approveExpense.changeReason,
      headerName: strings.ModuleSpecificUtilitie.approveExpense.CHANGE_REASON,
      width: expandedWidth.changeReason,
      editable: false,
      maxWidth: 300,
      sort: sortedDirection(
        strings.ModuleSpecificUtilitie.approveExpense.changeReason,
      ),
    },
    {
      field: strings.ModuleSpecificUtilitie.approveExpense.amountManagerPassed,
      headerName:
        strings.ModuleSpecificUtilitie.approveExpense.AMOUNT_PASSED_BY_MANAGER,
      width: 170,
      maxWidth: 200,
      cellRenderer: (params: any) => {
        return params?.data?.amountManagerPassed
          ? params?.data?.amountManagerPassed
          : '';
      },
      editable: false,
      sort: sortedDirection(
        strings.ModuleSpecificUtilitie.approveExpense.amountManagerPassed,
      ),
    },
    {
      field: strings.ModuleSpecificUtilitie.approveExpense.managerChangeReason,
      headerName:
        strings.ModuleSpecificUtilitie.approveExpense.CHANGE_REASON_BY_MANAGER,
      width: expandedWidth.managerChangeReason,
      maxWidth: 300,
      editable: false,
      sort: sortedDirection(
        strings.ModuleSpecificUtilitie.approveExpense.managerChangeReason,
      ),
    },
    {
      field: strings.ModuleSpecificUtilitie.approveExpense.amountAdminPassed,
      headerName:
        strings.ModuleSpecificUtilitie.approveExpense.AMOUNT_PASSED_BY_ADMIN,
      width: 200,
      editable: status?.expenseStatusId === 9,
      maxWidth: 200,
      cellStyle: (params: any) => style1(params),
      cellEditor: NumberInput,
      sort: sortedDirection(
        strings.ModuleSpecificUtilitie.approveExpense.amountAdminPassed,
      ),
    },
    {
      field: strings.ModuleSpecificUtilitie.approveExpense.adminChangeReason,
      headerName:
        strings.ModuleSpecificUtilitie.approveExpense.CHANGE_REASON_BY_ADMIN,
      width: expandedWidth.adminChangeReason,
      cellDataType: 'text',
      maxWidth: 300,
      cellStyle: (params: any) => style(params),
      editable: status?.expenseStatusId === 9,
      cellEditor: TextInput,
      sort: sortedDirection(
        strings.ModuleSpecificUtilitie.approveExpense.adminChangeReason,
      ),
    },
    {
      headerName: strings.ModuleSpecificUtilitie.approveExpense.VIEW,
      field: strings.ModuleSpecificUtilitie.approveExpense.miscBillPath,
      width: 150,
      cellRenderer: viewBill,
      editable: false,
      maxWidth: 200,
      sortable: false,
    },
    {
      headerName: strings.ModuleSpecificUtilitie.approveExpense.UPLOAD,
      field: strings.ModuleSpecificUtilitie.approveExpense.miscBillPath,
      width: 150,
      cellRenderer: renderUploadCell,
      editable: false,
      maxWidth: 200,
      sortable: false,
    },
  ];

  function convertBase64(blob: Blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader?.result);
      reader.readAsDataURL(blob);
    });
  }

  const changeHandlers = (event: any) => {
    void (async () => {
      try {
        const file = event?.target?.files;
        let upload = false;
        if (file !== undefined) {
          const data = new FormData();
          data?.append('expenseId', expenseId);
          data?.append('StaffpositionId', staffPositionId);
          data?.append('ExpenseCategory', 'MISC');
          for (let row of file) {
            if (row?.size < 3145728) {
              upload = true;
              data?.append('Files', row);
              data?.append('UploadedFileName', row?.name);
              const base64 = await convertBase64(row);
              data?.append('FilesBase64String', String(base64));
            } else {
              ToasterService.showToaster(
                strings.moduleSpecificUtilities.greaterThan3MB,
                ToastType.ERROR,
              );
            }
          }
          if (upload) {
            const tempArr = [...expenseApprovalsMisc];
            const index = tempArr?.findIndex(
              element => element?.expMiscHistoyId === expenseId,
            );
            tempArr[index] = {
              ...tempArr[index],
              miscBillPath: event?.target?.files[0]?.name,
            };

            dispatch(
              approveExpenseStateActions?.setMiscExpenseApprovalsData(tempArr),
            );
            dispatch(uploadMiscExpenseDataCreator(data));
          }
        }

        event.target.value = null;
      } catch (error) {}
    })();
  };

  const Input = styled('input')({
    display: 'none',
  });

  function colorChange(params: any) {
    let ChangeRowColor = false;
    if (
      params?.data?.amount &&
      params?.data?.amountClaimed &&
      params?.data?.amount != params?.data?.amountClaimed
    ) {
      return 'highlight';
    }
    if (miscEditedRowColorIndex?.length > 0) {
      miscEditedRowColorIndex?.forEach(function (element: any) {
        if (element === params?.data?.expMiscHistoyId) {
          ChangeRowColor = true;
        }
      });

      return ChangeRowColor && 'Open';
    }
  }

  const getRowId = useMemo(() => {
    return (params: any) => params?.data?.expMiscHistoyId;
  }, []);

  const request = (data: any) => {
    return {
      expMiscHistoyId: data?.expMiscHistoyId,
      StaffPositionId: data?.staffPositionId,
      Month: data?.expenseMonth,
      Year: data?.expenseYear,
      userId: data?.userId,
      adminApprovedMiscRemarks: data?.adminChangeReason,
      adminApprovedAmount: Number(data?.amountAdminPassed),
    };
  };
  const filterArr = (expMiscHistoyId: any, arr: any) => {
    return arr?.filter((user: any) => user !== expMiscHistoyId);
  };

  const condtionCheck = (data: any) =>
    ([
      strings.UnlockDeduction,
      strings.DAAdjustment,
      strings.TAAdjustment,
    ].includes(data?.expenseType) &&
      data?.amountAdminPassed <= 0) ||
    (data?.amountAdminPassed >= 0 &&
      ![strings.UnlockDeduction].includes(data?.expenseType)) ||
    ([strings.DAAdjustment, strings.TAAdjustment].includes(data?.expenseType) &&
      data?.amountAdminPassed >= 0);

  const resaonCon = (expenseApprovalsMisc: any, index: any, data: any) => {
    if (
      expenseApprovalsMisc[index]?.amountAdminPassed == data?.amountAdminPassed
    ) {
      if (miscEditedRowColorIndex.includes(data?.expMiscHistoyId)) {
        let updatedChildren = [...miscEditedRowColorIndex];
        const index = updatedChildren.indexOf(data?.expMiscHistoyId);
        if (index !== -1) {
          updatedChildren.splice(index, 1);
        }
        dispatch(
          approveExpenseStateActions.setMiscEditedRowColorIndex(
            updatedChildren,
          ),
        );
      }
    }
  };

  const resonValidation = (
    data: any,
    index: any,
    expenseApprovalsMisc: any,
  ) => {
    if (
      data?.adminChangeReason &&
      data?.adminChangeReason?.length >= 5 &&
      data?.adminChangeReason?.length <= 50 &&
      expenseApprovalsMisc[index]?.adminChangeReason != data?.adminChangeReason
    ) {
      dispatch(
        approveExpenseStateActions.setMiscEditedRowColorIndex(
          filterArr(data?.expMiscHistoyId, miscEditedRowColorIndex),
        ),
      );
      dispatch(miscSaveCreator(request(data)));
    }
    if (
      !data?.adminChangeReason &&
      (expenseApprovalsMisc[index]?.amountAdminPassed !=
        data?.amountAdminPassed ||
        expenseApprovalsMisc[index]?.adminChangeReason !=
          data?.adminChangeReason)
    ) {
      if (!miscEditedRowColorIndex?.includes(data?.expMiscHistoyId)) {
        dispatch(
          approveExpenseStateActions.setMiscEditedRowColorIndex(
            miscEditedRowColorIndex?.concat(data?.expMiscHistoyId),
          ),
        );
      }
      ToasterService.showToaster(
        strings.AdminChangeReasonisMandatory,
        ToastType.ERROR,
      );
      return;
    }
    if (
      data?.adminChangeReason &&
      data?.adminChangeReason?.length < 5 &&
      expenseApprovalsMisc[index]?.adminChangeReason != data?.adminChangeReason
    ) {
      if (!miscEditedRowColorIndex?.includes(data?.expMiscHistoyId)) {
        dispatch(
          approveExpenseStateActions.setMiscEditedRowColorIndex(
            miscEditedRowColorIndex?.concat(data?.expMiscHistoyId),
          ),
        );
      }
      ToasterService.showToaster(
        strings.moduleSpecificUtilities.minMaxChar,
        ToastType.ERROR,
      );
      return;
    }
    resaonCon(expenseApprovalsMisc, index, data);
    let save = condtionCheck(data);

    if (
      data?.adminChangeReason &&
      data?.adminChangeReason?.length >= 5 &&
      data?.adminChangeReason?.length <= 50 &&
      expenseApprovalsMisc[index]?.amountAdminPassed !=
        data?.amountAdminPassed &&
      save
    ) {
      if (!miscEditedRowColorIndex?.includes(data?.expMiscHistoyId)) {
        dispatch(
          approveExpenseStateActions.setMiscEditedRowColorIndex(
            miscEditedRowColorIndex?.concat(data?.expMiscHistoyId),
          ),
        );
      }
      dispatch(
        approveExpenseStateActions.setMiscEditedRowColorIndex(
          filterArr(data?.expMiscHistoyId, miscEditedRowColorIndex),
        ),
      );
      dispatch(miscSaveCreator(request(data)));
    }
  };
  const onRowValueChanged = useCallback(
    event => {
      dispatch(approveExpenseStateActions.setMiscTableWidth(expandedWidth));
      const data = event?.data;
      const tempArr = [...expenseApprovalsMisc];
      const index = expenseApprovalsMisc?.findIndex(
        (element: {expMiscHistoyId: any}) =>
          element?.expMiscHistoyId === data?.expMiscHistoyId,
      );
      let save = false;

      if (
        ([
          strings.UnlockDeduction,
          strings.DAAdjustment,
          strings.TAAdjustment,
        ].includes(data?.expenseType) &&
          data?.amountAdminPassed < 0) ||
        (data?.amountAdminPassed > 0 &&
          ![strings.UnlockDeduction].includes(data?.expenseType)) ||
        ([strings.DAAdjustment, strings.TAAdjustment].includes(
          data?.expenseType,
        ) &&
          data?.amountAdminPassed > 0)
      ) {
        save = true;
      }
      if (
        data?.adminChangeReason &&
        data?.adminChangeReason?.length >= 5 &&
        data?.adminChangeReason?.length <= 50 &&
        expenseApprovalsMisc[index]?.amountAdminPassed !=
          data?.amountAdminPassed &&
        save
      ) {
        dispatch(
          approveExpenseStateActions.setMiscEditedRowColorIndex(
            filterArr(data?.expMiscHistoyId, miscEditedRowColorIndex),
          ),
        );
        dispatch(miscSaveCreator(request(data)));
      } else {
        resonValidation(data, index, expenseApprovalsMisc);
      }
    },
    [expenseApprovalsMisc, miscEditedRowColorIndex, expandedWidth],
  );

  util.onViewBillClickfuntion = onViewBillClickfuntion;
  util.renderUploadCell = renderUploadCell;
  util.convertBase64 = convertBase64;
  util.changeHandlers = changeHandlers;
  util.uploadButton = uploadButton;
  util.colorChange = colorChange;
  util.viewBill = viewBill;
  util.onRowValueChanged = onRowValueChanged;
  util.style = style;
  util.resonValidation = resonValidation;
  util.request = request;
  util.filterArr = filterArr;
  util.condtionCheck = condtionCheck;

  /**
   * Handling the height of the grid table
   *
   * @method getTableHeight
   * @return {number}
   */
  const getTableHeight = (): number => {
    const rowCount = rowData?.length;
    if (rowCount > 11 || rowCount === 0) {
      return 375;
    } else {
      return rowCount * ROW_HIGHT + 68;
    }
  };

  const handleColumnResized = (event: any) => {
    if (!event?.column) {
      return;
    }
    const {column} = event;
    setExpandedWidth((prev: any) => ({
      ...prev,
      [column?.colId]: column.getActualWidth(),
    }));
  };

  const handleColumnResizedDebounce = debounce(handleColumnResized, 200);

  const onSortedChange = (params: any) => {
    const sortedColumns = params.columnApi
      .getAllColumns()
      .filter((col: any) => col.getSort());
    if (sortedColumns.length > 0) {
      const sortedColumn = sortedColumns[0];
      const field = sortedColumn.getColId();
      const sortDirection = sortedColumn.getSort();
      const miscSort = {
        field,
        sortDirection,
      };
      dispatch(approveExpenseStateActions.setMiscSort(miscSort));
    } else {
      const miscSort = {
        field: '',
        sortDirection: '',
      };
      dispatch(approveExpenseStateActions.setMiscSort(miscSort));
    }
  };

  const _onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  return (
    <>
      <div>
        <Box sx={dailyDataGrid(getTableHeight(), 75)}>
          <div
            style={{...styles.miscBox, height: getTableHeight()}}
            className="ag-theme-alpine">
            <AgGridReact
              rowData={rowData}
              columnDefs={columns}
              onRowValueChanged={onRowValueChanged}
              onColumnResized={handleColumnResizedDebounce}
              onSortChanged={onSortedChange}
              editType={'fullRow'}
              rowHeight={ROW_HIGHT}
              getRowId={getRowId}
              onGridReady={_onGridReady}
              defaultColDef={{
                sortable: true,
                resizable: true,
                suppressMovable: true,
                cellDataType: false,
              }}
              getRowClass={(params: any) =>
                `super-agetRowClassNamepp-theme--${colorChange(params)}`
              }
            />
          </div>
        </Box>
        <div>
          {nameColor?.map((item: any) => {
            return (
              <span key={item?.name} style={referColor}>
                <span
                  key={item?.name}
                  style={nameStyles(`${item?.color}`)}></span>{' '}
                {item?.name}
              </span>
            );
          })}
        </div>
      </div>
      <ViewBillPopup
        open={false}
        onClose={() => setBillPopup(false)}
        expenseId={expenseId}
      />

      <UploadBillPopup
        open={billPopup}
        onClose={() => setBillPopup(false)}
        changeHandlers={changeHandlers}
        uploadDisabled={status?.expenseStatusId !== 9}
        expenseId={expenseId}
      />
    </>
  );
};

export default ApproveExpenseMiscEditableGrid;

export const TextInput = memo(
  forwardRef((props: any, ref) => {
    const [value, setValue] = useState<string | undefined>(props?.value);
    let hasError = true;
    const refInput = useRef(null);
    if (value !== undefined) {
      if (value?.length >= 5 && value?.length <= 50) {
        hasError = false;
      }
    }
    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value;
        },

        isCancelBeforeStart() {
          return false;
        },
      };
    });

    return (
      <input
        ref={refInput}
        type="text"
        value={value}
        onChange={event => {
          let val = event?.target?.value
            ?.replace(/[^a-zA-Z0-9 ]/g, '')
            ?.trimStart();
          if (val?.length <= 50) {
            setValue(val ?? '');
          }
        }}
        className={`number-input ${hasError && 'number-input-error'}`}
      />
    );
  }),
);
export const nameColor = [
  {
    name: strings.WEEKOFFHOLIDAYLEAVE,
    color: theme.colors.LIGHT_GREEN,
  },
  {
    name: strings.POLICYVIOLATION,
    color: theme.colors.pink[300],
  },
  {
    name: strings.EDITABLEROW,
    color: theme.colors.yellow[700],
  },
];
